import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import isNumber from 'lodash/isNumber';
import React, { Component } from 'react';
import UI from '../ui';
import Utils from '../utils';

const { Logger } = Utils;
const { WrappedSlider } = UI;

class SliderFilters extends Component {
	constructor(props) {
		super(props);

		this.state = {
			eta: [0, 0], // the value of Primereact Slider component
			etaRange: {
				min: null,
				max: null,
			},

			price: [0, 0], // the value of Primereact Slider component
			priceRange: {
				min: null,
				max: null,
			},

			isDisabled: true,
		};

		// Slider change event handler with 500 ms delay
		this.notifyParent = debounce(this.notifyParent, 500);
	}

	componentDidUpdate(prevProps) {
		const { serviceResults } = this.props;

		// update the sliders boundaries only when Rates api is called and a new rates set is derived
		if (!isEqual(prevProps.serviceResults, serviceResults)) {
			this.updateBoundaries();
		}
	}

	notifyParent = (name, [min, max]) => {
		const { onFiltersChange } = this.props;
		const { isDisabled, etaRange } = this.state;

		// refresh Services view
		if (!isDisabled) {
			onFiltersChange(name, {
				min,

				// In UI, the slider range is between 1 and 11. The maximum days that the user can sets is 11,
				// which will show "10+" in the UI. This value here is used to determine whether services
				// should be filtered by the received maximum delivery days ("etaRange.max").
				max: name === 'eta' && max === 11 ? etaRange.max : max,
			});
		}

		// send log
		Logger.logToServer({
			category: 'ra_filter_change',
			ui_element: name === 'eta' ? 'ETA' : name,
			value: !isDisabled ? 'on' : 'off',
		});
	};

	updateBoundaries = () => {
		const { rateAdvisorData } = this.props;
		const { eta = {}, price = {} } = rateAdvisorData;
		const { etaRange, priceRange } = this.state;

		// calculate the new eta boundary
		const etaMin = isNumber(eta.min) ? eta.min : etaRange.min;
		const etaMax = isNumber(eta.max) ? eta.max : etaRange.max;

		// In UI, the slider range should be between 1 and 11 (maximum)
		const sliderEtaMax = isNumber(etaMax) && etaMax > 10 ? 11 : etaMax;

		// calculate the new price boundary
		const priceMin = isNumber(price.min) ? price.min : priceRange.min;
		const priceMax = isNumber(price.max) ? price.max : priceRange.max;

		this.setState({
			eta: [etaMin, sliderEtaMax],
			etaRange: {
				min: etaMin,
				max: etaMax,
			},
			price: [priceMin, priceMax],
			priceRange: {
				min: priceMin,
				max: priceMax,
			},
			isDisabled: priceMax === 0,
		});
	};

	onChange = ({ name, value }) => {
		this.setState(
			{
				[name]: value,
			},
			() => this.notifyParent(name, value)
		);
	};

	render() {
		const { eta, etaRange, price, priceRange, isDisabled } = this.state;
		const [etaMin, etaMax] = eta;

		return (
			<div className="common-rate-advisor-slider-filters">
				{/* ETA Filter */}
				<div className="slider-container">
					<h5 className="slider-label">
						<span>ETA: </span>
						{etaMin} - {etaMax > 10 ? '10+' : etaMax} Days
					</h5>
					<WrappedSlider
						range
						disabled={isDisabled}
						name="eta"
						value={eta}
						min={etaRange.min}
						max={etaRange.max > 10 ? 11 : etaRange.max}
						onChange={this.onChange}
						dataqa="rateadvisor-eta"
					/>
				</div>

				{/* Price Filter */}
				<div className="slider-container">
					<h5 className="slider-label">
						<span>Price: </span>${price[0]} - ${price[1]}
					</h5>
					<WrappedSlider
						range
						disabled={isDisabled}
						name="price"
						value={price}
						min={priceRange.min}
						max={priceRange.max}
						onChange={this.onChange}
						dataqa="rateadvisor-price"
					/>
				</div>
			</div>
		);
	}
}

export default SliderFilters;
